import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const leadApi = {
  submitLead: async (leadData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.LEADS}`, leadData);
      return response.data;
    } catch (error) {
      console.error('Error submitting lead:', error);
      throw error;
    }
  },
};

export default leadApi;